import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { DateTime } from 'luxon';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Collapse,
  Box,
  Typography,
  Divider,
  IconButton,
  Chip
} from '@mui/material';
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Receipt as ReceiptIcon,
  AttachMoney as AttachMoneyIcon
} from '@mui/icons-material';

const session = require('../../config/session');

class SaldoCajerosTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registros: [],
      filaExpandida: null
    };
  }

  handleExpand = (index) => {
    const yaExpandida = this.state.filaExpandida === index;
    if (yaExpandida) {
      this.setState({ filaExpandida: null });
    } else {
      this.setState({ filaExpandida: index });
    }
  }
  

  calcularArqueoPorDetalle = (detalle) => {
    const arqueoMap = new Map();
  
    try {
      if (!detalle || !detalle.detalle) {
        console.warn(`Sin detalle`);
        return [];
      }
  
      const arrayDetalle = `[${detalle.detalle}]`;
      const parsedDetalles = JSON.parse(arrayDetalle);
  
      parsedDetalles.forEach((contenido) => {
        const secciones = Object.values(contenido);
  
        secciones.forEach((seccion) => {
          if (seccion?.currencies?.length) {
            seccion.currencies.forEach((currency) => {
              if (currency?.bills?.length) {
                currency.bills.forEach((bill) => {
                  const denom = bill.denomination;
                  const cantidad = bill.amount;
  
                  arqueoMap.set(denom, (arqueoMap.get(denom) || 0) + cantidad);
                });
              }
            });
          }
        });
      });
    } catch (e) {
      console.error("Error parseando el detalle:", e, detalle.detalle);
    }
  
    return Array.from(arqueoMap.entries())
      .sort((a, b) => b[0] - a[0])
      .map(([denominacion, cantidad]) => ({
        denominacion,
        cantidad,
        subtotal: denominacion * cantidad
      }));
  };

  render(){
    const registros = this.props.registros;
    const { filaExpandida} = this.state;

    const columns = [
      { field: "desplegable", headerName: "", width: 70 },
      { field: "codigo_cajero", headerName: 'Codigo cajero', width: 180 },
      { field: "alias_cajero", headerName: 'Alias cajero', width: 150 },
      { field: "pais", headerName: 'Pais', width: 200 },
      { field: "ciudad", headerName: 'Ciudad', width: 70, align: 'right' },
      { field: "saldo_actual", headerName: 'Total', width: 120, align: 'right' }
    ];

    
    return(
          <Paper elevation={3} sx={{ 
            width: '100%', 
            overflow: 'hidden', 
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            mb: 3
          }}>
            <TableContainer>
              <Table stickyHeader sx={{ minWidth: 750 }}>
                <TableHead>
                  <TableRow sx={{
                    '& th': {
                      backgroundColor: 'primary.main',
                      color: 'primary.contrastText',
                      fontWeight: 'fontWeightBold',
                      fontSize: '0.8rem',
                      py: 1.5,
                      px: 2
                    }
                  }}>
                    {columns.map((column) => (
                      <TableCell
                        key={column.field}
                        sx={{
                          width: column.width,
                          textAlign: column.align || 'left',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {column.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
      
                <TableBody>
                  {registros.map((registro, index) => {
                    const estaAbierta = filaExpandida === index;
                    
                    const arqueo = this.calcularArqueoPorDetalle(registro);

                    return (
                      <React.Fragment key={registro.codigo_cajero}>
                        <TableRow sx={{
                          '&:hover': { backgroundColor: 'action.hover' },
                          '& td': { 
                            py: 1.5,
                            px: 2,
                            /* borderBottom: estaAbierta ? 'none' : undefined */
                          }
                        }}>
                          <TableCell>
                            <IconButton 
                              size="small" 
                              onClick={() => this.handleExpand(index)}
                              color={estaAbierta ? 'primary' : 'default'}
                            >
                              {estaAbierta ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            {session.checkPermiso('acceder_cajeros_resumen') ? (
                              <Link to={{ pathname: '/dashboard/cajeros/resumen', state: { id_cajero: registro.id_cajero } }}>
                                {registro.codigo_cajero}
                              </Link>
                              ) : (
                                <span>{registro.codigo_cajero}</span>
                              )}  
                          </TableCell>
                          <TableCell>{registro.alias_cajero}</TableCell>
                          <TableCell>{registro.pais}</TableCell>
                          <TableCell>{registro.ciudad}</TableCell>
                          <TableCell sx={{ 
                            fontWeight: 'fontWeightMedium',
                            textAlign: 'right',
                            color: 'success.main'
                          }}>
                            {registro.saldo_actual.toLocaleString()}
                          </TableCell>
                        </TableRow>
      
                        <TableRow>
                          <TableCell colSpan={9} sx={{ 
                            p: 0,
                            borderBottom: `1px solid`,
                            borderColor: 'divider'
                          }}>
                            <Collapse in={estaAbierta} timeout="auto">
                              {estaAbierta && (() => {
                                //const arqueo = this.calcularArqueoPorDetalle(registro);
                                const totalArqueo = arqueo.reduce((acc, item) => acc + item.subtotal, 0);

                                return (
                                  <Box sx={{ 
                                    backgroundColor: 'background.default',
                                    borderLeft: 4,
                                    borderColor: 'primary.main',
                                    p: 3
                                  }}>
                                    {/* Sección Arqueo */}
                                    <Box mt={6}>
                                      <Box display="flex" alignItems="center" mb={2}>
                                        <AttachMoneyIcon color="primary" sx={{ mr: 1 }} />
                                        <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                          Desglose de Efectivo
                                        </Typography>
                                      </Box>
                                      <Divider sx={{ mb: 2 }} />
                                      <Table size="small" sx={{ 
                                        '& th': {
                                          backgroundColor: 'action.selected',
                                          fontWeight: 'fontWeightBold'
                                        },
                                        '& td, & th': {
                                          py: 1,
                                          px: 2
                                        }
                                      }}>
                                        <TableHead>
                                          <TableRow>
                                            <TableCell sx={{ width: 100 }}>Denominacion</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>Cantidad</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>Subtotal</TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {arqueo.map((row, idx) => (
                                            <TableRow key={idx} hover>
                                              <TableCell>{row.denominacion.toLocaleString()}</TableCell>
                                              <TableCell sx={{ textAlign: 'right' }}>{row.cantidad}</TableCell>
                                              <TableCell sx={{ 
                                                textAlign: 'right',
                                                fontWeight: 'fontWeightMedium'
                                              }}>
                                                ${row.subtotal.toLocaleString()}
                                              </TableCell>
                                            </TableRow>
                                          ))}
                                        </TableBody>
                                        <TableFooter>
                                          <TableRow sx={{ 
                                            '& td': {
                                              fontWeight: 'fontWeightBold',
                                              backgroundColor: 'action.selected'
                                            }
                                          }}>
                                            <TableCell>Total</TableCell>
                                            <TableCell />
                                            <TableCell sx={{ textAlign: 'right' }}>
                                              {totalArqueo.toLocaleString()}
                                            </TableCell>
                                          </TableRow>
                                        </TableFooter>
                                      </Table>
                                    </Box>
                                  </Box>
                                );
                              })()}
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        );
  }
}






/* function Row(props) {
  var flagWidth = 25
  const {registro} = props;
  const [open, setOpen] = React.useState(false) 

  var detalleBoveda = JSON.parse(registro.detalle_boveda)

  var detalleAutomatico = detalleBoveda.automatico.currencies
  var filasBilletesAutomatico = []
  var filasMonedasAutomatico = []

  var detalleManual = detalleBoveda.manual.currencies
  var filasBilletesManual= []
  var filasMonedasManual = []

  var tablaTotales = []

  //Armar tabla de billetes y monedas de depositos automaticos
  for(var pais of detalleAutomatico) {
    var billetesPais = pais.bills
    var monedasPais = pais.coins

    if(pais.total_bills > 0) {
      tablaTotales.push(
        <tr>
          <td><PagoAutomaticoIcon /></td>
          <td>${pais.total_bills.toLocaleString()}</td>
          <td><img alt='x' src={'/bill.png'} width={20}/></td>
          <td><img alt='x' src={'/flags/' + pais.currency.toLowerCase() + '.png'} width={flagWidth} />{pais.currency}</td>
        </tr>
      )
    }
    if(pais.total_coins > 0) {
      tablaTotales.push(
        <tr>
          <td><PagoAutomaticoIcon /></td>
          <td>${pais.total_coins.toLocaleString()}</td>
          <td><img alt='x' src={'/coin.png'} width={20}/></td>
          <td><img alt='x' src={'/flags/' + pais.currency.toLowerCase() + '.png'} width={flagWidth} />{pais.currency}</td>
        </tr>
      )
    }
  
  //Billetes
  for(var billete of billetesPais) {
    filasBilletesAutomatico.push(
      <tr>
        <td><PagoAutomaticoIcon /></td>
        <td><img alt='x' src='/bill.png' width={20} /></td>
        <td><img alt='x' src={'/flags/' + pais.currency.toLowerCase() + '.png'} width={flagWidth} /></td>
        <td>${parseInt(billete.denomination).toLocaleString() + ' x ' + parseInt(billete.amount).toLocaleString()}</td>
      </tr>
    )
  }

  //Monedas
  for(var moneda of monedasPais) {
    filasMonedasAutomatico.push(
      <tr>
        <td><PagoAutomaticoIcon /></td>
        <td><img alt='x' src='/coin.png' width={20} /></td>
        <td><img alt='x' src={'/flags/' + pais.currency.toLowerCase() + '.png'} width={flagWidth} /></td>
        <td>${parseInt(moneda.denomination).toLocaleString() + ' x ' + parseInt(moneda.amount).toLocaleString()}</td>
      </tr>
    )
  }
} */

//Armar tabla de billetes y monedas de depositos manuales
/* eslint-disable no-redeclare */
/* for(var pais of detalleManual) {
  var billetesPais = pais.bills
  var monedasPais = pais.coins

  if(pais.total_bills > 0) {
    tablaTotales.push(
      <tr>
        <td><PagoManualIcon /></td>
        <td>${pais.total_bills.toLocaleString()}</td>
        <td><img alt='x' src={'/bill.png'} width={20}/></td>
        <td><img alt='x' src={'/flags/' + pais.currency.toLowerCase() + '.png'} width={flagWidth} />{pais.currency}</td>
      </tr>
    )
  }
  if(pais.total_coins > 0) {
    tablaTotales.push(
      <tr>
        <td><PagoManualIcon /></td>
        <td>${pais.total_coins.toLocaleString()}</td>
        <td><img alt='x' src={'/coin.png'} width={20}/></td>
        <td><img alt='x' src={'/flags/' + pais.currency.toLowerCase() + '.png'} width={flagWidth} />{pais.currency}</td>
      </tr>
    )
  } */

  //Billetes
 /*  for(var billete of billetesPais) {
    filasBilletesManual.push(
      <tr>
        <td><PagoManualIcon /></td>
        <td><img alt='x' src='/bill.png' width={20} /></td>
        <td><img alt='x' src={'/flags/' + pais.currency.toLowerCase() + '.png'} width={flagWidth} /></td>
        <td>${parseInt(billete.denomination).toLocaleString() + ' x ' + parseInt(billete.amount).toLocaleString()}</td>
      </tr>
    )
  } */

  //Monedas
 /*  for(var moneda of monedasPais) {
    filasMonedasManual.push(
      <tr>
        <td><PagoManualIcon /></td>
        <td><img alt='x' src='/coin.png' width={20} /></td>
        <td><img alt='x' src={'/flags/' + pais.currency.toLowerCase() + '.png'} width={flagWidth} /></td>
        <td>${parseInt(moneda.denomination).toLocaleString() + ' x ' + parseInt(moneda.amount).toLocaleString()}</td>
      </tr>
    )
  }
} */
/* eslint-enable no-redeclare */

/* var tablaDetalle = (
  <table>
    <tr>
      <td>
        {filasBilletesAutomatico}
      </td>
    </tr>
    <tr>
      <td>
        {filasMonedasAutomatico}
      </td>
    </tr>
    <tr>
      <td>
        {filasBilletesManual}
      </td>
    </tr>
    <tr>
      <td>
        {filasMonedasManual}
      </td>
    </tr>
  </table>
) */


 /* return (
   <React.Fragment>
     <TableRow>
      <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon />:<KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
       <TableCell>
       {registro.fecha_recaudo}
       </TableCell>
       <TableCell>
         {registro.cajero_alias}
       </TableCell>
       <TableCell>
         {registro.cajero_codigo}
       </TableCell>
       <TableCell>
         {registro.pais}
       </TableCell>
       <TableCell>
         {registro.ciudad}
       </TableCell>
       <TableCell>
         <table>
          {tablaTotales}
         </table>
       </TableCell>
     </TableRow>
     <TableRow>
     </TableRow>
     <TableRow>
      <TableCell style={{paddingTop: 0, paddingBottom: 0}} colSpan={10}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          {tablaDetalle}
        </Collapse>
      </TableCell>
     </TableRow>
   </React.Fragment>
 );
} */

/* class SaldoCajerosTable extends Component {

  constructor(props) {
    super(props)

    this.state = {
      registros: []
    };
  }



  componentDidMount() {
  }

  render() {
    var flagWidth = 25
    const registros = this.props.registros
  

    var totales = []

    // Recorrer todos los registros y tomar el detalle de la boveda
    for(var registro of registros) {
      var detalleBoveda = JSON.parse(registro.detalle_boveda)
      
      // Recorrer las monedas de pais de automatico
      for(var registroMonedaPais of detalleBoveda.automatico.currencies) {
        var monedaPais = registroMonedaPais.currency
        var tipoTransaccion = 'A'
        var totalSumar = 0
        var tipoMoneda = 'B'
        //Buscar si ya existe un tipo de moneda y transaccion para ver si se agrega al total o si se suma a uno ya existente

        //Buscar por coincidencia de billetes
        var agregarTotal = true
        totalSumar = registroMonedaPais.total_bills
        for(var indiceTotal in totales) {
          var totalGuardado = totales[indiceTotal]

          // Mirar si el tipo de transaccion es automatico y si coincide la moneda y si es billete
          if(totalGuardado.tipoTransaccion === tipoTransaccion && totalGuardado.moneda === monedaPais && totalGuardado.tipoMoneda === tipoMoneda) {
            agregarTotal = false
            totalGuardado.total += totalSumar
            console.log(totalSumar)
            totales[indiceTotal] = totalGuardado
            break
          }
        }

        // Agregar el total por sino existia previamente
        if(agregarTotal) {
          totales.push(
            {
              tipoTransaccion: tipoTransaccion,
              moneda: registroMonedaPais.currency,
              total: totalSumar,
              tipoMoneda: tipoMoneda
            }
          )
        }

        //Buscar por coincidencia de monedas
        tipoMoneda = 'M'
        agregarTotal = true
        totalSumar = registroMonedaPais.total_coins

        /* eslint-disable no-redeclare */
        /* for(var indiceTotal in totales) {
          var totalGuardado = totales[indiceTotal]

          // Mirar si el tipo de transaccion es automatico y si coincide la moneda y si es billete
          if(totalGuardado.tipoTransaccion === tipoTransaccion && totalGuardado.moneda === monedaPais && totalGuardado.tipoMoneda === tipoMoneda) {
            agregarTotal = false
            totalGuardado.total += totalSumar
            console.log(totalSumar)
            totales[indiceTotal] = totalGuardado
            break
          }
        } */
        /* eslint-enable no-redeclare */

        // Agregar el total por sino existia previamente
        /* if(agregarTotal) {
          totales.push(
            {
              tipoTransaccion: tipoTransaccion,
              moneda: registroMonedaPais.currency,
              total: totalSumar,
              tipoMoneda: tipoMoneda
            }
          )
        }


      } */

      // Recorrer las monedas de pais de manual
      /* eslint-disable no-redeclare */
      /* for(var registroMonedaPais of detalleBoveda.manual.currencies) {
        var monedaPais = registroMonedaPais.currency
        var tipoTransaccion = 'M'
        var totalSumar = 0
        var tipoMoneda = 'B'
        //Buscar si ya existe un tipo de moneda y transaccion para ver si se agrega al total o si se suma a uno ya existente

        //Buscar por coincidencia de billetes
        var agregarTotal = true
        totalSumar = registroMonedaPais.total_bills
        for(var indiceTotal in totales) {
          var totalGuardado = totales[indiceTotal]

          // Mirar si el tipo de transaccion es automatico y si coincide la moneda y si es billete
          if(totalGuardado.tipoTransaccion === tipoTransaccion && totalGuardado.moneda === monedaPais && totalGuardado.tipoMoneda === tipoMoneda) {
            agregarTotal = false
            totalGuardado.total += totalSumar
            console.log(totalSumar)
            totales[indiceTotal] = totalGuardado
            break
          }
        }

        // Agregar el total por sino existia previamente
        if(agregarTotal) {
          totales.push(
            {
              tipoTransaccion: tipoTransaccion,
              moneda: registroMonedaPais.currency,
              total: totalSumar,
              tipoMoneda: tipoMoneda
            }
          )
        }

        //Buscar por coincidencia de monedas
        tipoMoneda = 'M'
        agregarTotal = true
        totalSumar = registroMonedaPais.total_coins
        for(var indiceTotal in totales) {
          var totalGuardado = totales[indiceTotal]

          // Mirar si el tipo de transaccion es automatico y si coincide la moneda y si es billete
          if(totalGuardado.tipoTransaccion === tipoTransaccion && totalGuardado.moneda === monedaPais && totalGuardado.tipoMoneda === tipoMoneda) {
            agregarTotal = false
            totalGuardado.total += totalSumar
            console.log(totalSumar)
            totales[indiceTotal] = totalGuardado
            break
          }
        }

        // Agregar el total por sino existia previamente
        if(agregarTotal) {
          totales.push(
            {
              tipoTransaccion: tipoTransaccion,
              moneda: registroMonedaPais.currency,
              total: totalSumar,
              tipoMoneda: tipoMoneda
            }
          )
        }

      }
      /* eslint-enable no-redeclare */
  /*   }  */

    /* const columns = [
      {field: "desplegable", headerName: "", width: 10},
      {field: "fecha", headerName: 'Fecha Recaudo', width: 80},
      {field: "cajero_alias", headerName: 'Cajero-Alias', width: 150},
      {field: "cajero_codigo", headerName: 'Cajero-Codigo', width: 100},
      {field: "pais", headerName: 'País', width: 100},
      {field: "ciudad", headerName: 'Ciudad', width: 100},
      {field: "total", headerName: 'Total', width: 100}
    ] */

    /* return (
      <Paper sx={{ width: 1200, overflow: 'hidden' }}>
        <TableContainer>
          <Table stickyHeader className="table-data">
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  return(
                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {registros.map((registro) => {
                return(
                  <Row registro={registro} />
                )
              })}
            </TableBody>
          </Table>
          <Table sx={{width: '100%'}}>
            {totales.map((total) => {
              return(
                <TableRow sx={{margin: 1, padding: 1}}>
                  <TableCell sx={{width: '60%'}}></TableCell>
                  <TableCell></TableCell>
                  <TableCell>Total:</TableCell>
                  <TableCell></TableCell>
                  <TableCell align="right" sx={{width: 20}}>{total.tipoTransaccion === 'A' ? <PagoAutomaticoIcon /> : <PagoManualIcon />}</TableCell>
                  <TableCell align="right">${total.total.toLocaleString()}</TableCell>
                  <TableCell align="right" sx={{width: 20}}><img alt='x' src={total.tipoMoneda === 'B' ? '/bill.png' : '/coin.png'} width={20}/></TableCell>
                  <TableCell align="right">< img  alt='x' src={'/flags/' + total.moneda.toLowerCase() + '.png'} width={flagWidth} />{total.moneda}</TableCell>
                </TableRow>
              )
            })}
          </Table>
        </TableContainer>
      </Paper>
    ) */
/*   }
}  */

export default SaldoCajerosTable


